import React, { useContext, useEffect, useState } from 'react';
import {Button, Form, Modal} from 'react-bootstrap';
import { fetchResetPasswordLink, fetchResetPassword, fetchLogin } from '../API/apiservice';
import { useParams } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { LoadingSign } from "../Utility/loading-sign";
// import { ModalApiErrorMessage } from '../Utility/errorMessage';

export const PasswordReset = (props) => {
    const [credential, setCredential] = useState({email: '', password: '', confirmPassword: ''});
    // const [email, setEmail] = useState("");
    const [show, setShow] = useState(true);
    const handleClose = () => {setShow(false); window.location.href='../app/login'}
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [isApiError, setIsApiError] = useState(false);
    const [cookies, setCookie] = useCookies(['user']);
    const { guid } = useParams();

    const handleInputChange = (event) => {
        setCredential({...credential, [event.target.name]: event.target.value});
    }

    const requestResetLink = (event) => {
        setErrorMsg("");
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else{
            //window.location.href='../login'
            const sendResetLink = async () => {
                const data = await fetchResetPasswordLink(credential.email);
                if(Array.isArray(data) && data[0] == 'error')
                {
                    setErrorMsg("There was an error. Please try again.");
                }
                else {
                  if(data.success)
                  {

                  }
                  else if(data.error)
                  {
                    setErrorMsg(data.error);
                  }
                }
              };
              sendResetLink();
        }
        // handleClose();
        // console.log(credential);
        setValidated(true);
    };

    const resetPassword = (event) => {
        setErrorMsg("");
        event.preventDefault();
        if(credential.password === credential.confirmPassword)
        {
            const form = event.currentTarget;
            if (form.checkValidity() === false) {
                event.stopPropagation();
            }
            else{
                const resetPW = async () => {
                    const data = await fetchResetPassword(credential.password, guid);
                    if(Array.isArray(data) && data[0] == 'error')
                    {
                        setErrorMsg(data.error);
                    }
                    else {

                    if(data.success)
                    {
                        const param = {email: data.success, password: credential.password}
                        const validateUser = async () => {
                            setIsLoading(true);
                            const data = await fetchLogin(param);
                            if(Array.isArray(data) && data[0] == 'error')
                            {
                                setIsApiError(true);
                            }
                            else {
                              if(data.success)
                              {
                                setCookie('email', param.email, { path: '/', maxAge:86400});
                                setCookie('isCorporate', data.isCorporate, { path: '/', maxAge:86400});
                                setCookie('corpName', data.corpName, { path: '/', maxAge:86400});
                                // setCookie('customers', data.customers, { path: '/', maxAge:86400});
                                setCookie('warehouse', data.site, { path: '/', maxAge:86400});
                                localStorage.setItem('storeList', JSON.stringify(data.stores));
                                localStorage.setItem('customers', JSON.stringify(data.customers));

                                console.log("store names", data.stores);
                                props.setIsLoggedIn(true);
                              }
                              else if(data.error)
                              {
                                setErrorMsg(data.error);
                              }
                            }
                            setIsLoading(false);
                          };
                          validateUser();
                    }

                    }
                };
                resetPW();
            }
            // handleClose();
            // console.log(credential);
            setValidated(true);
        }
    };


    return (
        <div className="resetPwPage">
        <LoadingSign isLoading={isLoading} />
        <Modal className="resetPwModal" backdrop="static" show={show} onHide={handleClose}>

            <Modal.Header closeButton>
            <Modal.Title>Reset Password</Modal.Title>
            </Modal.Header>
            {(guid == "" || guid == undefined) ?
                <Form noValidate validated={validated} onSubmit={requestResetLink}>
                <Modal.Body>
                {errorMsg && <Form.Text className="errorMsg">*{errorMsg}<br/></Form.Text>}
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control type="email" name="email" placeholder="Enter email" value={credential.email} onChange={handleInputChange} required/>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" type="submit">
                        Get Reset Link
                    </Button>
                </Modal.Footer>
                </Form>
                :
                <Form noValidate validated={validated} onSubmit={resetPassword}>
                <Modal.Body>
                {errorMsg && <Form.Text className="errorMsg">*{errorMsg}<br/></Form.Text>}
    
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>New Password (8 or more characters)</Form.Label>
                        <Form.Control type="password" name="password" minLength="8" placeholder="Password" value={credential.password} onChange={handleInputChange}required/>
                    </Form.Group>
    
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Confirm New Password</Form.Label>
                        <Form.Control type="password" name="confirmPassword" placeholder="Confirm password" value={credential.confirmPassword} onChange={handleInputChange}required/>
                        {credential.password !== credential.confirmPassword && <span className='passwordMismathErrMsg'>*Passwords do not match.</span>}
                    </Form.Group>
    
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" type="submit">
                        Reset Password
                    </Button>
                </Modal.Footer>
                </Form>
            } 
        </Modal>
        </div>
    );
};